import React from 'react';
import { STATUS_APPLICATION_WAGON } from 'helpers/constants';
import { Select } from 'components/ui/formik';
import Form from '../form';
import styles from '../../../order.module.scss';

const Management = ({ edit, values, setStatus }) => {
  const isChangedStatus = edit.status !== Number(values.status);

  return (
    <>
      <div className={styles.item}>
        <Select
          label="Статус"
          name="status"
          onChange={({ target }) => setStatus(Number(target.value))}
        >
          {[
            STATUS_APPLICATION_WAGON.COMPLETE,
            STATUS_APPLICATION_WAGON.CANCEL,
            STATUS_APPLICATION_WAGON.WORK,
            STATUS_APPLICATION_WAGON.AGREED,
          ].map(value => (
            <option value={value} key={value}>
              {STATUS_APPLICATION_WAGON.toString(value)}
            </option>
          ))}
        </Select>
      </div>
      {isChangedStatus ? (
        <Form />
      ) : null}
    </>
  );
};

export default Management;
